import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {
    MonetaryConfig, MonetaryConfigListResponse,
} from "../http/protocol";


export class MonetaryConfigService  extends AbstractAdminEntityService<MonetaryConfig, MonetaryConfigListResponse>  {

    constructor(http : HttpService) {
        super("/bonus/monetary-config", http)
    }

}